import satflowAttributes from '../assets/fake-data/blockPiratesSatflowAttributes.json';

export const SATFLOW_COLLECTION_URL = 'https://www.satflow.com/ordinals/blockpirates';

export function getSatflowImageUrl(item) {
    const satflowItem = satflowAttributes.find((token) => token.galleryId === item.id);
    return satflowItem?.imageUrl;
}

export function getSatflowItemById(id) {
    return satflowAttributes.find((token) => String(token.itemId) === String(id));
}
